export const TOKENS = {
    FIREBASE_AUTH_TOKEN: 'FIREBASE_AUTH_TOKEN'
};
